module.exports = __webpack_public_path__ + "img/logo_loa.8c011061.png";